import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const Backspace = (props: IIconProps) => (
  <Icon viewBox="0 0 27 21" {...props}>
    <Path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.1532 6.63825C11.56 6.23146 12.2195 6.23146 12.6263 6.63825L19.4865 13.4984C19.8933 13.9052 19.8933 14.5648 19.4865 14.9716C19.0797 15.3784 18.4202 15.3784 18.0134 14.9716L11.1532 8.11139C10.7464 7.70459 10.7464 7.04505 11.1532 6.63825Z"
    />
    <Path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.0551 6.63825C18.6483 6.23146 17.9888 6.23146 17.582 6.63825L10.7218 13.4984C10.315 13.9052 10.315 14.5648 10.7218 14.9716C11.1286 15.3784 11.7881 15.3784 12.1949 14.9716L19.0551 8.11139C19.4619 7.70459 19.4619 7.04505 19.0551 6.63825Z"
    />
    <Path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.90143 2.16659L2.48476 10.4999L7.90143 18.8333H22.9167C23.492 18.8333 23.9583 18.3669 23.9583 17.7916V3.20825C23.9583 2.63296 23.492 2.16659 22.9167 2.16659H7.90143ZM6.77083 20.9166L0 10.4999L6.77083 0.083252H22.9167C24.6426 0.083252 26.0417 1.48236 26.0417 3.20825V17.7916C26.0417 19.5175 24.6426 20.9166 22.9167 20.9166H6.77083Z"
    />
  </Icon>
);

export default Backspace;
